import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-calender',
  styleUrls: ['./calender.component.scss'],
  templateUrl: './calender.component.html'
})
export class CalenderComponent {}
